import { PHONE_NUMBER } from '@/constants/Common'
import { LocaleEvent } from '../en/event'

const event: LocaleEvent = {
  events: 'Sự Kiện',
  eventsNearMe: 'Sự Kiện Gần Tôi',
  myEvents: 'Sự Kiện Của Tôi',
  explore: 'Khám Phá',
  eventStatus: 'Trạng Thái Sự Kiện',
  addABracket: 'Thêm Một Nhóm',
  editEvent: 'Chỉnh Sửa Sự Kiện',
  endEvent: 'Kết Thúc Sự Kiện',
  addAnAnnouncement: 'Thêm Thông Báo',
  submitPayment: 'Nộp Phí',
  register: 'Đăng Ký',
  registrationClosed: 'Đăng Ký Đã Đóng',
  registered: 'Đã Đăng Ký',
  aboutTheEvent: 'Về Sự Kiện',
  announcements: 'Thông Báo',
  noMoreAnnouncements: 'Không còn thông báo nào.',
  eventRegistration: 'Đăng Ký Sự Kiện',
  clubMembership: 'Hội Viên Câu Lạc Bộ',
  clubMembershipQuestion: 'Bạn có phải là thành viên của câu lạc bộ tổ chức không?',
  contactDetails: 'Thông Tin Liên Hệ',
  selectYourBrackets: 'Chọn Nhóm Của Bạn',
  competitionDates: 'Ngày Thi Đấu',
  invitedPlayer: 'Người Chơi Được Mời',
  invitedPlayerTooltip:
    'Bạn đã được mời tham gia sự kiện này bởi đối tác của bạn. Để chấp nhận hoặc từ chối lời mời này, vui lòng đến mục "nhóm của tôi" trên bảng điều khiển người chơi của bạn.',
  ineligibleBracket: 'Nhóm Không Hợp Lệ',
  registrationFull: 'Đăng Ký Đầy',
  registerForWaitlist: 'Đăng Ký Vào Danh Sách Chờ',
  totalPaymentDue: 'Tổng Số Tiền Phải Thanh Toán (1 Sự Kiện)',
  inviteSent: 'Lời Mời Đã Gửi',
  offers: 'Ưu Đãi',
  eventPolicies: 'Chính Sách Sự Kiện',
  iAgreeText: 'Tôi đã đọc và đồng ý với',
  healthAndSafetyPolicy: 'Chính Sách Sức Khỏe và An Toàn',
  liabilityPolicy: 'Chính Sách Trách Nhiệm',
  registeredSuccessfully: 'Bạn đã thanh toán và đăng ký thành công.',
  registrationComplete: 'Đăng Ký Hoàn Tất',
  registrationCompleteText:
    'Đăng ký của bạn đã hoàn tất. Bạn có thể chỉnh sửa thông tin đăng ký từ trang chủ nhóm của bạn, có thể truy cập thông qua bảng điều khiển.',
  continueToPayment: 'Tiếp Tục Thanh Toán',
  addPhoneNumber: 'Thêm Số Điện Thoại',
  editPhoneNumber: 'Chỉnh Sửa Số Điện Thoại',
  bracketDetails: 'Chi Tiết Nhóm',
  players: 'Người Chơi',
  teams: 'Đội',
  matches: 'Trận Đấu',
  partnerConfirmed: 'Đối Tác Đã Xác Nhận',
  noPartnerSelected: 'Chưa Chọn Đối Tác',
  partnerPending: 'Đối Tác Đang Chờ Xử Lý',
  viewDraws: 'Xem Bản Vẽ',
  seedMatches: 'Sắp Xếp Trận Đấu',
  editBracket: 'Chỉnh Sửa Nhóm',
  endBracket: 'Kết Thúc Nhóm',
  withdraw: 'Rút Lui',
  editPartner: 'Chỉnh Sửa Đối Tác',
  removePartner: 'Xóa Đối Tác',
  addPartner: 'Thêm Đối Tác',
  reopenBracket: 'Mở Lại Nhóm',
  confirmWithdrawFromBracket: 'Bạn có chắc chắn muốn rút lui khỏi nhóm này không?',
  contactTheEventOrganizer:
    'Nếu bạn dự định yêu cầu hoàn lại tiền, hãy liên hệ với người tổ chức sự kiện trước khi rút lui.',
  toRegisterFor: 'Để đăng ký cho',
  answerCompleteThePrecess: 'Trả lời các chi tiết sau để hoàn tất quá trình.',
  declineInvite: 'Từ chối lời mời',
  declineInviteFirstDesc: 'Bạn có chắc chắn muốn từ chối',
  declineInviteSecondDesc: 'lời mời tham gia sự kiện này không?',
  exitTheQueue: 'Thoát Hàng Đợi',
  exitTheQueueDesc:
    'Thoát khỏi hàng đợi nếu bạn đã tìm thấy sân cho trận đấu tiếp theo của mình. Sân phải sẵn sàng, và bạn phải có mặt tại sân khi bạn quyết định thoát khỏi hàng đợi.',
  WL: 'Thắng/Thua',
  pointDiff: 'Chênh Lệch Điểm',
  waitlisted: 'Trong Danh Sách Chờ',
  switchBracket: 'Chuyển Đổi Nhóm',
  switchBrackets: 'Chuyển Đổi Các Nhóm',
  switch: 'Chuyển Đổi',
  addParticipant: 'Thêm Người Tham Gia',
  switchBracketsConfirmation: 'Bạn có chắc chắn muốn chuyển đổi nhóm cho đội được chọn không?',
  withdrawPlayer: 'Rút Người Chơi',
  confirmWithdrawPlayerFirstText: 'Bạn có chắc chắn muốn loại bỏ',
  confirmWithdrawPlayerSecondText: 'khỏi nhóm này không?',
  withdrawRefund: 'Rút Lui/Hoàn Tiền',
  addABracketParticipant: 'Thêm Người Tham Gia Nhóm',
  selectAPlayer: 'Chọn một người chơi từ danh sách dưới đây.',
  addABracketParticipantDesc:
    'Các tài khoản không thể được chọn là chưa được yêu cầu/dự mời. Những người chơi bị ảnh hưởng phải đăng ký tài khoản để có thể được chọn.',
  memberOfHostClub: 'Người chơi có phải là thành viên của câu lạc bộ tổ chức không?',
  selectBracketsToSwitch: 'Chọn nhóm để chuyển đổi',
  confirmTeam: 'Xác Nhận Đội',
  editTeam: 'Chỉnh Sửa Đội',
  splitTeam: 'Tách Đội',
  replace: 'Thay Thế',
  addAPartner: 'Thêm Đối Tác',
  addAPartnerDesc:
    'Nếu đối tác của bạn đã là người dùng DUPR, bạn có thể thêm họ vào đội của mình bằng cách tìm kiếm trong danh bạ này. Nếu đối tác của bạn chưa đăng ký với DUPR, bạn có thể mời họ vào đội của mình qua email.',
  teamConfirmed: 'Đội Đã Xác Nhận',
  teamPending: 'Đội Đang Chờ Xử Lý',
  showUnclaimedAccountsDesc:
    'Các tài khoản không thể được chọn là chưa được yêu cầu/mời. Các cầu thủ bị ảnh hưởng phải đăng ký tài khoản để có thể được chọn.',
  replaceTeamDesc:
    'Bạn có thể thay thế đội đã đăng ký này bằng bất kỳ đội nào đang chờ trong danh sách chờ cho nhóm này. Khi bạn thực hiện lựa chọn, các trận đấu sẽ được gieo lại tự động trong nhóm nguồn và nhóm đích. Chọn từ các đội được liệt kê dưới đây.',
  confirmEditTeam: 'Bạn có chắc chắn muốn chỉnh sửa đội không?',
  confirmThisTeams: 'Bạn có chắc chắn muốn xác nhận đội này không?',
  createTeam: 'Tạo Đội',
  playersDifferentGenders: 'Cầu thủ phải khác giới tính',
  unmatchedTeams: 'Đội Không Đối Sánh',
  pleaseSelectAnyTwoPlayers: 'Vui lòng chọn bất kỳ hai cầu thủ nào từ danh sách này để tạo một đội',
  youSelectedTwoPlayersSameGender:
    'Bạn đã chọn hai cầu thủ cùng giới tính. Vì đây là nhóm trộn, tất cả các đội phải chứa một nam và một nữ.',
  thisTeamCannotCreated: 'Đội này không thể được tạo vì',
  and: 'và',
  isOnTheWaitlist: 'đang ở trong danh sách chờ. Vui lòng tạo đội từ những cầu thủ không nằm trong danh sách chờ.',
  afterYouConfirm: 'Sau khi bạn xác nhận lựa chọn này, những cầu thủ này sẽ được chuyển đến tab "đội"',
  youLikeToCreateTeam: 'Bạn có chắc chắn muốn tạo đội này không?',
  forfeit: 'Từ Bỏ',
  bye: 'Chào',
  forfeitMatch: 'Trận Từ Bỏ',
  forfeitMatchDesc: 'Vui lòng chọn đội đã từ bỏ trận đấu. Đội bạn chọn sẽ được coi là đã thua trận đấu.',
  teamA: 'Đội A',
  teamB: 'Đội B',
  markAsForfeit: 'Đánh Dấu Là Từ Bỏ',
  youCanAddScores: 'Bạn có thể thêm điểm số giữa những ngày này',
  titleSubmitScoreModal: 'Nộp Điểm Số cho Tất Cả Các Trận',
  scoreWarningMessage:
    'Bạn phải hoàn thành trận đấu và nộp điểm số cho tất cả các trận trong trận đấu của bạn cùng một lúc. Nếu bạn dự định nộp điểm số cho các trận đấu khác trong trận đấu này, hãy quay lại.',
  editingScoresTitle: 'Chỉnh Sửa Điểm Số của Sự Kiện Đã Hoàn Thành',
  editingScoresFirstDesc:
    'Bạn đang chỉnh sửa điểm số của một sự kiện đã hoàn thành. Bảng xếp hạng và các trận đấu tương lai của sự kiện này sẽ không bị ảnh hưởng.',
  editingScoresSecondDesc: ' Bạn sẽ mất tính toàn vẹn của dữ liệu trong Biểu Đồ và bảng xếp hạng của sự kiện này. ',
  stillContinue: 'Bạn có muốn tiếp tục không?',
  submitScores: 'Nộp Điểm Số',
  submittingScoresTitle: 'Gửi điểm số mới này sẽ ảnh hưởng đến các trận đấu đã lên lịch',
  submittingScoresFirstDesc:
    'Bạn đã chọn người chiến thắng mới, một số trận đấu ở vòng tiếp theo sẽ được lên lịch lại.',
  submittingScoresSecondDesc:
    'Nếu các cầu thủ đã có mặt trên sân và bạn không muốn chỉnh sửa các trận đấu hiện tại, hãy nhấn Quay Lại. Bạn luôn có thể chỉnh sửa điểm số cho từng trận đấu sau khi sự kiện kết thúc. Nếu bạn muốn tiếp tục với các trận đấu mới, hãy Nộp Điểm Số.',
  editScores: 'Chỉnh Sửa Điểm Số',
  addScores: 'Thêm Điểm Số',
  deleteBracketMatchDesc:
    'Nếu bạn xóa trận đấu này, bạn sẽ phải bắt đầu lại từ đầu để nhập điểm số và ảnh hưởng đến xếp hạng của mình.',
  validateMatch: 'Xác Nhận Trận Đấu',
  validateMatchDesc: `Bạn có chắc chắn muốn xác nhận điểm số này không? Nếu vậy, trận đấu sẽ được hoàn tất và xếp hạng cầu thủ sẽ được cập nhật. Nếu điểm số này không chính xác, vui lòng liên hệ với giám đốc sự kiện hoặc nhắn tin ${PHONE_NUMBER} với điểm số chính xác.`,
  validate: 'Xác Nhận',
  substitutes: 'Người Thay Thế',
  selectParticipant: 'Chọn một người tham gia từ danh sách dưới đây.',
  totalAmountPaid: 'Tổng Số Tiền Đã Thanh Toán',
  showDetail: 'Hiển Thị Chi Tiết',
  playerStatus: 'Trạng Thái Cầu Thủ',
  paymentStatus: 'Trạng Thái Thanh Toán',
  amountPaid: 'Số Tiền Đã Thanh Toán',
  amountRefunded: 'Số Tiền Đã Hoàn Lại',
  bracketName: 'Tên Nhóm',
  pricing: 'Định Giá',
  pricingDesc:
    'Cầu thủ phải trả phí tham gia sự kiện cộng với phí mỗi nhóm để thi đấu trong một sự kiện. Giá sự kiện cũng có thể thay đổi tùy thuộc vào việc bạn có phải là thành viên của câu lạc bộ tổ chức hay không.',
  eventEntryFee: 'Phí Tham Gia Sự Kiện',
  bracketPrice: 'Giá Nhóm',
  importantDates: 'Ngày Quan Trọng',
  importantDatesDesc:
    'Cầu thủ phải trả phí tham gia sự kiện cộng với phí mỗi nhóm để thi đấu trong một sự kiện. Giá sự kiện cũng có thể thay đổi tùy thuộc vào việc bạn có phải là thành viên của câu lạc bộ tổ chức hay không.',
  registrationDates: 'Ngày Đăng Ký',
  registrationLimit: 'Giới Hạn Đăng Ký',
  numberTeamsPermitted: 'Số Đội Được Phép',
  waitlistAllowance: 'Cho Phép Danh Sách Chờ',
  allowedWaitlist: 'Số Đội Được Phép Trong Danh Sách Chờ',
  bracketType: 'Loại Nhóm',
  roundRobin: 'Round Robin',
  roundRobinDesc:
    'Một giải đấu vòng tròn là cuộc thi mà mỗi thí sinh lần lượt gặp tất cả các thí sinh khác. Giải đấu vòng tròn trái ngược với giải đấu loại trực tiếp, trong đó người tham gia bị loại sau một số lần thua nhất định.',
  waterfall: 'Waterfall',
  waterfallDesc:
    'Định dạng giải đấu Waterfall với 16 đội đảm bảo rằng mỗi đội chơi đúng 4 trận. Nhóm được gắn nhãn với 8 hướng trên la bàn (Bắc, Nam, Đông, Tây, Đông Bắc, Tây Bắc, Đông Nam và Tây Nam). Trong mỗi trận, mỗi đội sẽ thi đấu với đội có trình tự thắng thua chính xác giống nhau.',
  flexLeague: 'Giải Đấu Linh Hoạt',
  flexLeagueDesc:
    'Giải đấu DUPR Flex League, tương tự như giải đấu vòng tròn, là cuộc thi mà mỗi thí sinh gặp tất cả các thí sinh khác lần lượt. Các cầu thủ tự tổ chức các trận đấu theo sở thích, và những sự kiện này thường diễn ra trong khoảng thời gian dài.',
  numberCourts: 'Số Sân',
  playerGroup: 'Nhóm Cầu Thủ',
  playerRules: 'Quy Tắc Người Chơi',
  skillLevel: 'Trình Độ Kỹ Năng',
  ageGroup: 'Nhóm Tuổi',
  menDoubles: 'Các cầu thủ sẽ thi đấu theo đội hai người. Mỗi đội phải bao gồm 2 cầu thủ nam.',
  womenDoubles: 'Các cầu thủ sẽ thi đấu theo đội hai người. Mỗi đội phải bao gồm 2 cầu thủ nữ.',
  mixedDoubles: 'Các cầu thủ sẽ thi đấu theo đội hai người. Mỗi đội phải bao gồm một cầu thủ nam và một cầu thủ nữ.',
  openDoubles: 'Các cầu thủ sẽ thi đấu theo đội hai người. Cầu thủ có thể thuộc bất kỳ sự kết hợp giới tính nào',
  acceptPartner: 'Chấp Nhận Đối Tác',
  leagueConsentTitle: 'Thông Tin Liên Lạc Của Bạn Sẽ Được Chia Sẻ',
  leagueConsentDesc:
    'Một khi bạn đăng ký cho sự kiện này, email và số điện thoại của bạn chỉ hiển thị cho các cầu thủ khác đã đăng ký cho sự kiện. Điều này cho phép các cầu thủ liên lạc với nhau để sắp xếp trận đấu.',
  noQualifyingBrackets: 'Không Có Nhóm Đủ Điều Kiện',
  noQualifyingBracketsTitle:
    'Bạn không đủ điều kiện cho bất kỳ nhóm mở nào trong sự kiện này dựa trên xếp hạng DUPR, tuổi và hồ sơ giới tính của bạn.',
  pleaseContactEventAdministrator: 'Vui lòng liên hệ với quản trị viên sự kiện tại',
  pleaseContactText: 'nếu bạn tin rằng đây là một sai lầm.',
  step1: 'Bước 1: Vui lòng chọn một lựa chọn và tiếp tục',
  refundOnly: 'Chỉ Hoàn Tiền',
  withdrawAndRefund: 'Rút Lui và Hoàn Tiền',
  step2: 'Bước 2',
  event: 'sự kiện',
  bracketsOf: 'nhóm của',
  total: 'Tổng Cộng',
  paymentPending: 'Thanh Toán Đang Chờ Xử Lý',
  freeEvent: 'Sự Kiện Miễn Phí',
  fullyRefundedEvent: 'Sự Kiện Được Hoàn Tiền Toàn Bộ',
  partiallyRefundedEvent: 'Sự Kiện Được Hoàn Tiền Một Phần',
  fullyRefunded: 'Đã Hoàn Tiền Toàn Bộ',
  splitTeamFirst: 'Tách Đội Trước',
  freeBracket: 'Nhóm Miễn Phí',
  partiallyRefunded: 'Được Hoàn Tiền Một Phần',
  viewQualifyingPartners: 'Xem Đối Tác Đủ Điều Kiện',
  viewQualifyingPartnersDesc:
    'Danh sách người dùng DUPR này chỉ hiển thị các đối tác tiềm năng đủ điều kiện cho nhóm này dựa trên xếp hạng, tuổi và giới tính được nêu.',
  joiningWaitlist: 'Bạn Đang Tham Gia Danh Sách Chờ',
  joiningWaitlistDesc:
    'Bạn đã chọn tham gia danh sách chờ cho ít nhất một nhóm của bạn. Bạn sẽ được thông báo bởi ban quản lý giải đấu nếu bạn được chuyển khỏi danh sách chờ.',
  fromSelectedBrackets: 'từ các nhóm được chọn?',
  sureRefundATotalAmount: 'Bạn có chắc chắn muốn hoàn lại tổng số tiền của',
  sureRemove: 'Bạn có chắc chắn muốn loại bỏ',
  seedMatchesDesc: 'Nhấn Gieo Hạt Trận Đấu để Gieo Hạt Đội',
  createMatches: 'Tạo Trận Đấu',
  seeds: 'Hạt Giống',
  reseedMatches: 'Gieo Hạt Lại',
  bracketCreated: 'Bảng Đấu Đã Được Tạo.',
  endEventTitleModal: 'Bạn có chắc chắn muốn kết thúc sự kiện này không?',
  endEventModalDesc:
    'Bạn sẽ không thể thay đổi sự kiện này nữa sau khi chọn đánh dấu nó là hoàn thành. Sự kiện sẽ bị đánh dấu là không hoạt động vĩnh viễn.',
  moveToUnmatchedTab:
    'Sau khi rút người chơi này, họ sẽ được chuyển đến tab Người Chơi Chưa Ghép. Từ đó, bạn có thể thêm người chơi này vào đội khác hoặc rút hoàn toàn khỏi sự kiện.',
  endBracketModalTitle: 'Bạn có chắc chắn muốn kết thúc bảng đấu này không?',
  endBracketModalDesc: 'Bạn sẽ không thể thay đổi bảng đấu này nữa sau khi chọn đánh dấu nó là hoàn thành.',
  removePartnerFirstDesc: 'Bạn có chắc chắn muốn từ chối',
  removePartnerSendDesc: 'lời mời tham gia sự kiện này không?',
  reopenBracketDesc:
    'Khi bạn mở lại bảng đấu này, bạn sẽ có thể thêm điểm số và chỉnh sửa thông tin cho đến ngày kết thúc bảng đấu.',
}

export default event
